import { Field} from '@progress/kendo-react-form';
import { FileUpload, FieldInput, DialogProps, DisputeDialog, DisputeEventResult, DisputeField, ResolutionReasonComboBox, resolutionReasonValidator } from 'components';
import { DisputeEventTypes } from 'enums';
import { useDisputeService } from 'services';
import { useFileUploadValidator } from 'hooks';
import { useUserInfo } from 'state';
import styles from './DenyDispute.module.scss';

/**
 * DenyDispute component allows the user to deny a dispute.
 * 
 * @param props - Additional properties passed to the Dialog
 * @returns Rendered component
 */
const DenyDispute = (props: DialogProps) => {
    const disputeService = useDisputeService();
    const filesValidator = useFileUploadValidator(0);
    const { isFinalApprover } = useUserInfo();
    
    const onSubmit = async (data: any) => {
        const { disputeNumber, files, reason, ...rest } = data;

        const fileData = files?.map((file: any) => file.getRawFile()) ?? [];

        const result = await disputeService?.resolveDispute(disputeNumber, {
            ...rest,
            eventTypeId: DisputeEventTypes.DisputeDenied,
            resolutionReasonId: reason.resolutionReasonId
        }, fileData);
        return {
            error: !result && 'Error saving dispute'
        } as DisputeEventResult;
    };

    return (
        <DisputeDialog
            initialValues={{ isPublic: false }}
            title="Deny Dispute"
            submitLabel="Deny"
            routeToNext={!isFinalApprover}
            onSubmit={onSubmit}
            {...props}
        >
            <DisputeField
                name="reason"
                className={styles.reason}
                component={ResolutionReasonComboBox}
                validator={resolutionReasonValidator}
                type={DisputeEventTypes.DisputeDenied}
            />
            <Field
                component={FieldInput}
                child={FileUpload}
                label="Please provide any additional documentation."
                name="files"
                validator={filesValidator}
            />  
        </DisputeDialog>
    );
};

export default DenyDispute;